import { apiFetch } from "./client";

// Emails waiting for approval (and any still sending).
export function listEmailDrafts() {
  return apiFetch("/api/admin/emails");
}

export function getEmailDraft(id) {
  return apiFetch(`/api/admin/emails/${id}`);
}

export function saveEmailDraft(id, patch) {
  return apiFetch(`/api/admin/emails/${id}`, { method: "PUT", body: patch });
}

/** A ready-to-send nudge for one Follow-ups item: {kind, quote_id} or {kind: "nudge_lead", lead_id}. */
export function createNudge(body) {
  return apiFetch("/api/admin/emails/nudge", { method: "POST", body });
}

/** Nudges sent lately: [{kind, quote_id, lead_id, sent_at}]. */
export function recentNudges() {
  return apiFetch("/api/admin/emails/nudges");
}

/** A blank email to everyone on the list. */
export function newEmailToList() {
  return apiFetch("/api/admin/emails", { method: "POST", body: {} });
}

export function previewEmail(draft) {
  return apiFetch("/api/admin/emails/preview", { method: "POST", body: draft });
}

export function sendTestEmail(id, edits) {
  return apiFetch(`/api/admin/emails/${id}/test`, { method: "POST", body: edits });
}

/** Saves the edits, locks in the recipients and sends the first batch. */
export function approveEmail(id, edits) {
  return apiFetch(`/api/admin/emails/${id}/approve`, { method: "POST", body: edits });
}

/** Sends the next batch. Call until `remaining` is 0. */
export function continueSending(id) {
  return apiFetch(`/api/admin/emails/${id}/send`, { method: "POST", body: {} });
}

/** Claude rewrites the draft as asked; pass the unsaved subject and body too. */
export function rewriteEmail(id, instruction, current) {
  return apiFetch(`/api/admin/emails/${id}/rewrite`, { method: "POST", body: { instruction, ...current } });
}

/** This month's newsletter, drafted now (or the one already waiting). */
export function draftNewsletterNow() {
  return apiFetch("/api/admin/emails/newsletter", { method: "POST", body: {} });
}

// The no-reply emails to quiet leads.
export function getLeadCampaign() {
  return apiFetch("/api/admin/lead-campaign");
}

export function saveLeadCampaign(patch) {
  return apiFetch("/api/admin/lead-campaign", { method: "PUT", body: patch });
}

export function previewLeadCampaign(step, steps) {
  return apiFetch("/api/admin/lead-campaign/preview", { method: "POST", body: { step, steps } });
}

export function testLeadCampaign(step, steps) {
  return apiFetch("/api/admin/lead-campaign/test", { method: "POST", body: { step, steps } });
}

// What Claude knows about Birdie Bus when it writes.
export function getAiWriting() {
  return apiFetch("/api/admin/ai-writing");
}

export function saveAiWriting(facts) {
  return apiFetch("/api/admin/ai-writing", { method: "PUT", body: { facts } });
}

export function dismissEmail(id) {
  return apiFetch(`/api/admin/emails/${id}/dismiss`, { method: "POST", body: {} });
}

export function emailHistory() {
  return apiFetch("/api/admin/emails/history");
}

export function getEmailSettings() {
  return apiFetch("/api/admin/email/settings");
}

export function saveEmailSettings(patch) {
  return apiFetch("/api/admin/email/settings", { method: "PUT", body: patch });
}

/** Pull new waivers from the website and draft anything due, now. */
export function syncEmailNow() {
  return apiFetch("/api/admin/email/sync", { method: "POST", body: {} });
}

export function listContacts(q = "") {
  return apiFetch(`/api/admin/contacts?q=${encodeURIComponent(q)}`);
}

export function unsubscribeContact(id) {
  return apiFetch(`/api/admin/contacts/${id}/unsubscribe`, { method: "POST", body: {} });
}

export function importContacts(csv) {
  return apiFetch("/api/admin/contacts/import", { method: "POST", body: { csv } });
}

// Public unsubscribe page (no sign-in).
export function getUnsubscribe(token) {
  return apiFetch(`/api/public/email/unsubscribe/${encodeURIComponent(token)}`);
}

export function confirmUnsubscribe(token) {
  return apiFetch(`/api/public/email/unsubscribe/${encodeURIComponent(token)}`, { method: "POST", body: {} });
}

export function resubscribe(token) {
  return apiFetch(`/api/public/email/resubscribe/${encodeURIComponent(token)}`, { method: "POST", body: {} });
}
